import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const ORDER_ENDPOINT = "/public/order"

const defaultValues = {
  orderType: 'order',
  types: [],
  preferredDate: null,
  gdpr: false,

  customer: {
    companyName: null,
    firstName: null,
    lastName: null,
    telephone: null,
    email: null,
    address: {
      address: null,
      postalCode: null,
      city: null,
      region: null,
      country: null
    }
  },
  owner1: {
    firstName: null,
    lastName: null
  },
  owner2: {
    firstName: null,
    lastName: null
  },
  broker: {
    companyName: null,
    firstName: null,
    lastName: null,
    telephone: null,
    email: null,
    address: {
      address: null,
      postalCode: null,
      city: null,
      region: null,
      country: null
    }
  },

  estateNumber: null,
  estateLocation: null,

  objectAddress: {
    address: null,
    postalCode: null,
    city: null,
    region: null,
    country: null
  }
}

export default new Vuex.Store({
  state: {
    tenant: null,
    organization: null,
    logo: null,

    loading: 0,

    orderForms: [],
    orderTypes: [],
    inspectionTypes: [],
    calendarEvents: [],

    attributes: {},

    customerAddress: {},
    brokerAddress: {},
    ownerAddress: {},
    objectAddress: {},

    form: JSON.parse(JSON.stringify(defaultValues)),
  },

  mutations: {
    setTenant (state, tenant) {
      state.tenant = tenant
      //localStorage.setItem('tenant', tenant)
    },
    setLoading (state, arg) {
      if (arg) {
        state.loading++
      } else if (state.loading > 0) {
        state.loading--
      }
    },
    setPreferredDate (state, date) {
      state.form.preferredDate = date
    },
    setOwnerInfo (state, { firstName, lastName, address }) {
      state.form.owner1.firstName = firstName
      state.form.owner1.lastName = lastName
      state.form.objectAddress = { ...address }
    },
    setOrganization (state, org) {
      state.organization = org
    },
    setLogo (state, dataUrl) {
      state.logo = dataUrl
    },
    setOrderTypes (state, list) {
      state.orderTypes = list
      if(!state.form.orderType && (list && list.length > 0)) {
        state.form.orderType = list[0].name
      }
    },
    setInspectionTypes (state, list) {
      state.inspectionTypes = list
    },
    setOrderForms (state, list) {
      state.orderForms = list
    },
    setAttribute(state, { name, value }) {
      state.attributes[name] = value
    },
    setCalendarEvents (state, list) {
      state.calendarEvents = list
    },
    resetForm (state) {
      state.attributes = {}
      state.form = JSON.parse(JSON.stringify(defaultValues))
    },
  },

  actions: {
    startLoading ({ commit }) {
      commit('setLoading', true)
    },
    stopLoading ({ commit }) {
      commit('setLoading', false)
    },
    getTenant ({ state }) {
      return state.tenant
    },
    // eslint-disable-next-line no-unused-vars
    API ({ state }, serviceName) {
      const tenant = state.tenant
      const prefix = '/' + encodeURIComponent(tenant) + '/v1/' + serviceName
      return Promise.resolve({
        http: axios,
        tenant: tenant,
        url: prefix,
        get: (url, config) => axios.get(prefix + url, config),
        post: (url, body, config) => axios.post(prefix + url, body, config),
        put: (url, body, config) => axios.put(prefix + url, body, config),
        delete: (url, config) => axios.delete(prefix + url, config)
      })
    },
    fetchOrderMetadata ({ commit, dispatch }) {
      return new Promise(function (resolve, reject) {
        dispatch('startLoading', null, { root: true })
        dispatch('API', 'vb')
          .then(api => api.get(ORDER_ENDPOINT))
          .then(response => {
            const result = response.data
            commit('setOrganization', result.organization)
            commit('setOrderTypes', result.orderTypes)
            commit('setOrderForms', result.forms)
            commit('setInspectionTypes', result.inspectionTypes)
            if(result.organization.logo) {
              return dispatch('content/downloadContentAsDataURL', result.organization.logo)
                .then(dataUrl => commit('setLogo', dataUrl))
                .then(() => resolve(result))
            } else {
              resolve(result)
            }
          })
          .catch(err => reject(err))
          .finally(dispatch('stopLoading', null, { root: true }))
      })
    },
    getNextPossibleDate ({ commit, dispatch }) {
      return new Promise(function (resolve, reject) {
        dispatch('startLoading', null, { root: true })
        dispatch('API', 'vb')
          .then(api => api.get(ORDER_ENDPOINT + '/nextDate'))
          .then((response) => {
            const date = response.data.date
            commit('setPreferredDate', date)
            resolve(date)
          })
          .catch(err => reject(err))
          .finally(dispatch('stopLoading', null, { root: true }))
      })
    },
    getCalendarEvents ({ commit, dispatch }) {
      return new Promise(function (resolve, reject) {
        dispatch('startLoading', null, { root: true })
        dispatch('API', 'vb')
          .then(api => api.get(ORDER_ENDPOINT + '/events'))
          .then((response) => {
            const dates = response.data
            commit('setCalendarEvents', dates)
            resolve(dates)
          })
          .catch(err => reject(err))
          .finally(dispatch('stopLoading', null, { root: true }))
      })
    },
    saveOrder ({ dispatch }, data) {
      return new Promise(function (resolve, reject) {
        dispatch('startLoading', null, { root: true })
        dispatch('API', 'vb')
          .then(api => api.post(ORDER_ENDPOINT, data))
          .then((response) => resolve(response.data))
          .catch(err => reject(err))
          .finally(dispatch('stopLoading', null, { root: true }))
      })
    },
    setOwnerInfo ({ commit }, from) {
      commit('setOwnerInfo', from)
    },
    resetForm ({ commit }) {
      commit('resetForm')
      return Promise.resolve()
    },
    fetchGalleryImages ({ dispatch }, id) {
      return new Promise(function (resolve, reject) {
        dispatch('startLoading', null, { root: true })
        dispatch('API', 'vb')
          .then(api => api.get(ORDER_ENDPOINT + '/gallery/' + encodeURIComponent(id)))
          .then((response) => resolve(response.data))
          .catch(err => reject(err))
          .finally(dispatch('stopLoading', null, { root: true }))
      })
    }
  },
  getters: {
    organization: (state) => state.organization,
    setting: (state) => (key) => state.organization?.attributes[key],
    orderForms: (state) => state.orderForms,
    customer: (state) => state.form.customer,
    owner: (state) => state.form.owner1,
    owner2: (state) => state.form.owner2,
    object: (state) => {
      return {
        location: state.form.estateLocation,
        number: state.form.estateNumber,
        address: state.form.objectAddress,
      }
    },
    broker: (state) => state.form.broker,

    website: (state) => {
      const url = state.organization?.website
      if (url) {
        if (url.includes(':')) {
          return url
        }
        return 'http://' + url
      }
      return null
    },
    calendarEvents: (state) => state.calendarEvents || [],
  }
})
